import $ from 'jquery';
import {MasonryHelper} from './MasonryHelper';

export class Gallery {
  public static frontend(el: HTMLElement, opt: any) {
    return new this($(el), opt);
  }

  public state: boolean;
  public masonry: MasonryHelper;

  constructor(public $elem: JQuery, public opt) {
    this.state = false;

    opt.hero ? this.gridLayout() : this.masonryLayout();
    this.$elem.on('me-show', () => {
      if (this.state && this.masonry) {
        this.masonry.update();
      }
    });
  }

  public masonryLayout() {
    this.masonry = new MasonryHelper(
      this.$elem.get(0).firstElementChild.firstElementChild.firstElementChild,
    );
    if (this.$elem.parent().find('.heroimg').length > 0) {
      this.$elem.prepend(
        $('<div class="item"></div>').append(
          this.$elem.siblings('.heroimg').children(),
        ),
      );
      this.$elem.siblings('.heroimg').remove();
    }
    this.state = true;
  }

  public gridLayout() {
    if (this.masonry && this.state) {
      this.masonry.destroy();
    }
    this.state = false;
  }
}
